<template>
  <section class="ef">
    <div class="ef__big-container">
      <div class="ef__container">
        <img
          id="formSticker"
          src="/v2/ege/form/heart-sticker.png"
          alt="heart"
          class="ef__sticker"
        >

        <div class="ef__left">
          <h2
            class="ef__title"
            v-html="title"
          />

          <p class="ef__description">
            Напишите нам в отделе заботы через форму или в удобный для вас мессенджер.
            Мы свяжемся с вами с 8:00-20:00 и ответим на любые вопросы
          </p>

          <div class="ef__social">
            <a
              href="https://wa.me/79686286327"
              target="_blank"
              rel="nofollow"
              class="whatsapp"
            >
              <img
                src="/v2/ege/form/whatsapp.svg"
                alt="whatsapp"
              >
            </a>
            <a
              :href="$telegramBotLink($route)"
              target="_blank"
              rel="nofollow"
              class="telegram"
            >
              <img
                src="/v2/ege/form/telegram.svg"
                alt="telegram"
              >
            </a>
            <a
              href="mailto:BPrusakov@synergy.ru"
              target="_blank"
              rel="nofollow"
              class="email"
            >
              <img
                src="/v2/ege/form/email.svg"
                alt="email"
              >
            </a>
          </div>

          <img
            :src="image"
            alt="photo"
            class="ef__photo"
          >
        </div>

        <div class="ef__right">
          <div class="ef__form">
            <form-name-field
              ref="nameField"
              v-model="nameInput"
              class="ef__form--input"
              placeholder="Имя"
            />

            <form-phone-field
              ref="phoneField"
              v-model="phoneInput"
              class="ef__form--input ef__form--input-phone"
              :errors-list="submitError"
              :error="validForm === false"
            />

            <form-email-field
              ref="emailField"
              v-model="emailInput"
              class="ef__form--input ef__form--input-email"
              :submit-error="submitError"
              placeholder="Почта"
              @clearSubmitError="clearSubmitError"
            />

            <button
              class="ef__form--button"
              @click="submit"
            >
              Получить консультацию
            </button>

            <p class="ef__form--law">
              Нажимая на кнопку, вы соглашаетесь
              <br>
              <nuxt-link :to="routeIsArsenal ? '/privacy-arsenal' : '/privacy'">
                на условия обработки данных
              </nuxt-link>
            </p>
          </div>
        </div>
      </div>

      <div class="ef__bg" />
    </div>
  </section>
</template>

<script>
import routeIsArsenal from '~/utils/routeIsArsenal';
import { getQuestionnairePath } from '@/utils/questionnairePath';
import FormNameField from '@/components/v2/common/fileds/FormNameField.vue';
import FormEmailField from '@/components/v2/common/fileds/FormEmailField.vue';
import FormPhoneField from '@/components/v2/common/fileds/FormPhoneField.vue';
import sendLeadMixinConstructor from '@/mixins/sendLeadMixinConstructor';

const sendLeadMixin = sendLeadMixinConstructor({
  needPhone: true,
  needEmail: true,
  needToSendTitle: false,
});

export default {
  name: 'ExamForm',
  components: {
    FormPhoneField,
    FormEmailField,
    FormNameField,
  },
  mixins: [sendLeadMixin],
  props: {
    title: {
      type: String,
      default: 'Мы можем вам <br>чем-то помочь?',
    },
    image: {
      type: String,
      default: '/v2/ege/form/photo.png',
    },
  },

  computed: {
    routeIsArsenal() {
      return routeIsArsenal(this.$route.name);
    },
  },

  methods: {
    onSubmit() {
      this.$router.push(getQuestionnairePath(this.$route));
    },
  },
};
</script>

<style lang="scss" scoped>
.ef {
  &__big-container {
    position: relative;
    width: calc(100% - 120px);
    margin: 0 60px;
    padding: 100px 8px 0;
    overflow: hidden;

    border-radius: 60px;
    background-color: $white-color;

    @media (max-width: 1480px) {
      width: 100%;
      max-width: 1360px;
      margin: 0 auto;
    }

    @include media-down(laptop) {
      padding: 50px 8px 0;

      border-radius: 30px;
    }

    @include media-down(tablet) {
      padding: 56px 8px;
    }

    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;

      display: block;

      background: url('/v2/ege/pluses/background.svg');
      opacity: .5;

      pointer-events: none;

      @include media-down(tablet) {
        background-size: 950px;
      }
    }
  }

  &__container {
    width: 100%;
    max-width: 1240px;
    margin: 0 auto;
    position: relative;
    z-index: 1;

    display: flex;
    justify-content: space-between;
    gap: 20px;

    @include media-down(tablet) {
      flex-direction: column;
      gap: 32px;
    }
  }

  &__sticker {
    width: 55px;
    position: absolute;
    top: -30px;
    left: calc(50% - 42.5px);

    @include media-down(tablet) {
      left: auto;
      right: 25px;
      top: 180px;
    }
  }

  &__left {
    position: relative;
    z-index: 1;
    width: calc(50% - 10px);

    @include media-down(tablet) {
      width: 100%;
    }
  }

  &__title {
    font-size: 45px;
    font-weight: 700;
    line-height: 111%;
    letter-spacing: -0.03em;
    text-transform: uppercase;
    color: $black-color;

    @include media-down(laptop) {
      font-size: 30px;
    }

    @include media-down(tablet) {
      padding: 0 8px;
    }
  }

  &__description {
    max-width: 526px;
    margin-top: 10px;

    font-size: 24px;
    font-weight: 500;
    line-height: 130%;
    color: $grey2;

    @include media-down(laptop) {
      font-size: 20px;
    }

    @include media-down(tablet) {
      padding: 0 40px 0 8px;
      margin-top: 12px;
      line-height: 100%;
    }

    @include media-down(mobile) {
      padding: 0 8px;
    }
  }

  &__social {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    margin-top: 20px;

    @include media-down(mobile) {
      margin-top: 32px;
    }

    a {
      display: inline-block;
      width: 50px;
      height: 50px;
      overflow: hidden;

      border-radius: 10px;
      transform: translate(-2px, -2px);

      transition: transform .2s ease-out, box-shadow .2s ease-out;

      img {
        width: 100%;
      }
    }
    a.whatsapp {
      border: 2px solid #168B25;
      box-shadow: 2px 2px 0 0 #168B25;

      &:hover {
        transform: translate(0, 0);
        box-shadow: 0 0 0 0 #168B25;
      }
    }
    a.telegram {
      border: 2px solid #016EA3;
      box-shadow: 2px 2px 0 0 #016EA3;

      &:hover {
        transform: translate(0, 0);
        box-shadow: 0 0 0 0 #016EA3;
      }
    }
    a.email {
      border: 2px solid #044396;
      box-shadow: 2px 2px 0 0 #044396;

      &:hover {
        transform: translate(0, 0);
        box-shadow: 0 0 0 0 #044396;
      }
    }
  }

  &__photo {
    width: 100%;
    margin-top: -50px;

    @include media-down(tablet) {
      display: none;
    }
  }

  &__right {
    width: calc(50% - 10px);

    @include media-down(tablet) {
      width: 100%;
    }
  }

  &__form {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 84px 60px;

    border-radius: 20px;
    background-color: $white-color;
    box-shadow: 4px 4px 20px 0 rgba($ege-blue-darkest, .05), 10px 10px 50px 0 rgba($ege-blue-darkest, .1);

    @include media-down(laptop) {
      padding: 20px;
    }

    @include media-down(tablet) {
      padding: 56px 8px;
      gap: 4px;
    }

    ::v-deep &--input {
      input {
        width: 100%;
        height: 74px;
        padding: 22px 20px;

        border-radius: 100px;
        border: 1px solid rgba($black-color, .2);

        font-size: 20px;
        font-weight: 400;
        line-height: normal;
        letter-spacing: 0.4px;

        transition: border .3s ease, color .3s ease;

        @include media-down(laptop) {
          height: 60px;
          padding: 15px 20px;
        }

        @include media-down(tablet) {
          height: 64px;
          padding: 14px 16px;

          font-size: 16px;
        }
      }

      input::placeholder {
        color: $grey2;
        transition: color .3s ease;
      }

      &-phone {
        input {
          border: none;
          padding-left: 65px;
          background-color: transparent;
          height: 100%;
        }
      }
    }

    &--button {
      margin-top: 10px;
      width: 100%;
      height: 74px;
      display: flex;
      align-items: center;
      justify-content: center;

      border-radius: 100px;
      border: 2px solid $brown-dark;
      background-color: $ege-orange;
      box-shadow: 0 4px 0 0 $brown-dark;

      font-family: 'TildaSans', sans-serif;
      font-size: 30px;
      font-weight: 700;
      line-height: 100%;
      color: $white-color;

      cursor: pointer;
      transition: transform .2s ease-out, box-shadow .2s ease-out;

      @include media-down(laptop) {
        height: 60px;
        font-size: 24px;
      }

      @include media-down(tablet) {
        height: 64px;
        margin-top: 6px;
      }

      &:hover {
        transform: translate(0, 4px);
        box-shadow: 0 0 0 0 $brown-dark;
      }
    }

    &--law {
      margin-top: 20px;

      font-size: 18px;
      font-weight: 600;
      line-height: 100%;
      color: $grey2;
      text-align: center;

      a {
        text-decoration: none;
        color: $header-dark-orange;
      }

      @include media-down(tablet) {
        margin-top: 12px;
        font-size: 16px;
      }
    }
  }

  &__bg {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 2.89%;
    width: 13.88%;
    height: 32.89%;

    background-color: #9867FF;
    opacity: .5;
    filter: blur(100px);

    @include media-down(tablet) {
      width: 48.61%;
      height: 20.83%;
      left: 100%;
      bottom: auto;
      top: 29.3%;
    }
  }
}
</style>
